import { createAuthClient } from 'better-auth/react';
import { magicLinkClient } from 'better-auth/client/plugins';

// Same-origin in dev (Vite proxies /api -> :8787). In production, set
// VITE_API_URL to the deployed API origin and Better-Auth will use it.
const baseURL = import.meta.env.VITE_API_URL || window.location.origin;

export const authClient = createAuthClient({
  baseURL: `${baseURL}/api/auth`,
  plugins: [magicLinkClient()],
});
